// extracted by mini-css-extract-plugin
export default {"root":"InitConsts_root__-U0pq"};